var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.595 392.328L145.595 504.328C136.501 514.109 119.501 514.109 110.407 504.328L6.407 392.328C-0.077 385.344 -1.811 375.156 2.001 366.406S14.454 352 24.001 352H79.999V160H23.999C14.452 160 5.812 154.344 1.999 145.594C-1.813 136.844 -0.079 126.656 6.405 119.672L110.405 7.672C119.499 -2.109 136.499 -2.109 145.593 7.672L249.593 119.672C256.077 126.656 257.812 136.844 253.999 145.594C250.187 154.344 241.546 160 231.999 160H175.999V352H232.001C241.548 352 250.189 357.656 254.001 366.406S256.079 385.344 249.595 392.328Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDown);
export default __webpack_public_path__ + "static/media/up-down.9e73702006dde5e46e57ee33b9610bdc.svg";
export { ForwardRef as ReactComponent };